import { SignInForm } from '@medplum/react'
import { cn } from '@seen/ui'
import type { JSX } from 'react'
import { Logo } from '#src/components/core/Logo.tsx'
import { PageLayout } from '#src/components/display/PageLayout.tsx'

export function SignInPageComponent({
  medplumProjectId,
  medplumGoogleClientId,
  onSignIn,
  disableEmailAuth = true,
}: {
  medplumProjectId: string
  medplumGoogleClientId: string
  onSignIn?: () => void
  disableEmailAuth?: boolean
}): JSX.Element {
  return (
    <div className="isolate flex size-full min-h-full flex-col bg-frame text-frame-foreground">
      <PageLayout
        contentClassName={cn(
          '*:grid *:w-full *:place-items-center',
          'justify-center [&>*>*]:w-full'
        )}
      >
        <SignInForm
          projectId={medplumProjectId}
          googleClientId={medplumGoogleClientId}
          disableEmailAuth={disableEmailAuth}
          scope="openid offline_access"
          onSuccess={onSignIn}
        >
          <div className="flex flex-col items-center gap-8 pt-8">
            <Logo size={40} announce />
            <h1>Sign in to Seen Orbit</h1>
          </div>
        </SignInForm>
      </PageLayout>
    </div>
  )
}
